import React from "react";
import Hero from "./Hero";
import About from "./About";
import Experience from "./Experience";

const Homepage = () => {
  return (
    <div>
      <Hero />
      <About />
      <Experience />
    </div>
  );
};

export default Homepage;
